import { View } from "binder"
import { MachineTypeEditorViewModel } from "./machineTypeEditor-viewModel"

export class MachineTypeEditorView extends View<MachineTypeEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-58064BE2-25CA-4E98-9D91-98BF0D3A7E1A"
    }
    loadHtml(): string {
        let element = require('./machineTypeEditor.html').default;
        let style = require('./machineTypeEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
